import { render } from "./DocumentTypesView.vue?vue&type=template&id=9fa27d5a"
import script from "./DocumentTypesView.vue?vue&type=script&lang=js"
export * from "./DocumentTypesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__